import * as React from "react";
import { forwardRef } from "react";
const SvgBullet = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z" }));
const ForwardRef = forwardRef(SvgBullet);
export default ForwardRef;
